namespace TabAurous.Common {
    export enum AdditionalChargesProductCalcon {
        NetAmount = 1,
        NetandLabor = 2
    }
    Serenity.Decorators.registerEnumType(AdditionalChargesProductCalcon, 'TabAurous.Common.AdditionalChargesProductCalcon', 'Administration.AdditionalChargesProduct');
}
